/**
 * Streaming hide for <think> — never rewrite already visible text.
 * Unclosed think is held back; closed think is dropped; prefix stays.
 */
export class ThinkVisibleBuffer {
  #pending = '';
  #depth = 0;
  visible = '';

  push(chunk: string): string {
    if (!chunk) return '';
    let remaining = this.#pending + chunk;
    this.#pending = '';
    let added = '';
    while (remaining.length > 0) {
      if (this.#depth > 0) {
        const close = remaining.indexOf('</think>');
        if (close === -1) {
          const lt = remaining.lastIndexOf('<');
          if (lt >= 0 && '</think>'.startsWith(remaining.slice(lt))) {
            this.#pending = remaining.slice(lt);
          }
          break;
        }
        remaining = remaining.slice(close + '</think>'.length);
        this.#depth = Math.max(0, this.#depth - 1);
        continue;
      }
      const open = remaining.search(/<think\b[^>]*>/i);
      if (open === -1) {
        const lt = remaining.lastIndexOf('<');
        if (lt >= 0 && '<think'.startsWith(remaining.slice(lt).toLowerCase())) {
          added += remaining.slice(0, lt);
          this.#pending = remaining.slice(lt);
        } else {
          added += remaining;
        }
        break;
      }
      added += remaining.slice(0, open);
      const match = remaining.slice(open).match(/^<think\b[^>]*>/i);
      remaining = remaining.slice(open + (match?.[0].length ?? 7));
      this.#depth += 1;
    }
    if (added) this.visible += added;
    return added;
  }

  finish(): string {
    if (this.#depth === 0 && this.#pending) {
      this.visible += this.#pending;
      const added = this.#pending;
      this.#pending = '';
      return added;
    }
    this.#pending = '';
    this.#depth = 0;
    return '';
  }
}

export function stripClosedThinkTags(text: string): string {
  return text
    .replace(/<think\b[^>]*>[\s\S]*?<\/think>/gi, '')
    .replace(/<\/think>/gi, '')
    .trim();
}
